import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Barcode from 'react-barcode';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PatPrint(props) {
  const [appData, setAppData] = useState([]);
  const [hospData, setHospData] = useState([]);
  const { pat_id } = useParams();
  useEffect(() => {
    try {
      axios.get(`${baseUrl}pat-id/${pat_id}/`).then(function (response) {
        setAppData(response.data);
      });
    } catch (error) {
      console.log(error);
    }
    try {
      axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
        setHospData(response.data);
      });
    } catch (error) {
      console.log(error);
    }
  }, []);
   const handlePrint = () => {
    const printContents = document.getElementById('invoice-print').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    setTimeout(() => {
        window.location.reload();
    }, 1000);
    document.body.innerHTML = originalContents;
 };

  return (
    <section className="container mt-4">
      <h3 className="text-center" style={{ color: "black", backgroundColor: "#e5eaef" }}>
        <i className="fa-solid fa-qrcode" aria-hidden="true" style={{ color: "black" }}></i> Patient Details Print
      </h3>
      <div className="row nurseInpatient">
        <div className="col-md-12" id="invoice-print">
          <table width="100%" border="1">
            <tbody>
              <tr>
                {hospData.map((hospital) => (
                  <td colspan="2" align="right">
                    <p align="center">
                      <strong>{hospital.hospital}</strong>
                      <br></br>Address&nbsp;: &nbsp;{hospital.address}
                    </p>
                  </td>
                ))}
              </tr>
              {appData.map((app) => (
                <>
                  <tr align="center">
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>Reg.On : {app.add_date}</td>

                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>UHID : <b>{app.pat_id}</b></td>
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>Name : {app.patient},</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>Age : {app.age}/{app.gender}</td>
                    <td style={{ fontWeight: "bold", paddingLeft: "18px" }}>Mobile : {app.mobile}</td>
                  </tr>
                  <tr><td style={{fontWeight: 'bold', paddingLeft: '18px'}}>Addr. : <b>{app.address1}</b></td></tr>
                 <tr><td style={{fontWeight: 'bold', paddingLeft: '18px'}}>Weight : <b></b></td></tr>
                 <tr><td style={{fontWeight: 'bold', paddingLeft: '18px'}}>BP : <b></b></td></tr>
                 <tr><td style={{fontWeight: 'bold', paddingLeft: '18px'}}>Temp : <b></b></td></tr>

                 </>
                 ))}
             </tbody>
             </table>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
              onClick={handlePrint}
              >
               Print
              </button>
            </div>
    </section>
  )
}

export default PatPrint;
